import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row items-center" }
const _hoisted_2 = { class: "text-h5 text-navy-700" }
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = {
  key: 0,
  class: "col"
}
const _hoisted_5 = { class: "row items-center" }
const _hoisted_6 = {
  key: 1,
  class: "row items-center"
}
const _hoisted_7 = { class: "row items-center q-pb-md" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "row items-center q-pb-sm" }
const _hoisted_10 = { class: "col-2" }

import { is } from "quasar"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import SfxNumericSelector from "src/components/input/SfxNumericSelector.vue"
import SfxSelectInequality from "src/components/select/SfxSelectInequality.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxTimeEdit from "src/components/special/SfxTimeEdit.vue"
import { RegularWorkFilter } from "src/stores/filterStore"
import { REGULAR_WORK_FILTERS_DEFAULT } from "src/util/constants/filters"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { showWarningNotification } from "src/util/functions/notifications"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import { computed, PropType, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxFilterRegularWork',
  props: /*#__PURE__*/_mergeModels({
  workDomainOptions: {
    type: Array as PropType<WorkDomainWorkspace[]>,
    required: true,
  },
}, {
    "regularWorkFilters": { required: true },
    "regularWorkFiltersModifiers": {},
  }),
  emits: ["update:regularWorkFilters"],
  setup(__props) {

const regularWorkFilters = _useModel<RegularWorkFilter>(__props, "regularWorkFilters")

const props = __props

//endregion

//region Variables

const { t } = useI18n()

const showFilterSection = ref(true)
const hasFilters = ref(false)

const timeLineOptions = [
  { value: "latest", label: t("sfxDialogFilter.latest") },
  { value: "none", label: t("sfxDialogFilter.none") },
  { value: "any", label: t("sfxDialogFilter.any") },
]
const calendricalOptions = [
  { value: "days", label: t("sfxDialogFilter.days") },
  { value: "months", label: t("sfxDialogFilter.months") },
  { value: "years", label: t("sfxDialogFilter.years") },
]

const filterExpandIconClasses = computed(() =>
  showFilterSection.value ? "sfx-rotate-dropdown-icon__0" : "sfx-rotate-dropdown-icon__180"
)

const filterExpandSectionClasses = computed(() =>
  showFilterSection.value ? "sfx-filter-section" : ""
)

const endDateClasses = computed(() =>
  !regularWorkFilters.value?.performedRange?.startDate ? "non-interactive" : ""
)

//endregion

//region Lifecycle
//endregion

//region Functions

function handleFiltersSection() {
  showFilterSection.value = !showFilterSection.value
}

function resetFilters() {
  regularWorkFilters.value = structuredClone(REGULAR_WORK_FILTERS_DEFAULT)
}

//endregion

//region Setup Code

watch(
  () => regularWorkFilters.value,
  () => {
    hasFilters.value = !is.deepEqual(regularWorkFilters.value, REGULAR_WORK_FILTERS_DEFAULT)
  },
  { deep: true, immediate: true }
)

// When there is a start date with no start time, set the start time to 00:00 automatically.
// We need to do this because the API always expects a time.
watch(
  () => regularWorkFilters.value.performedRange?.startDate,
  () => {
    if (
      regularWorkFilters.value.performedRange &&
      !regularWorkFilters.value.performedRange.startTime
    ) {
      regularWorkFilters.value.performedRange.startTime = "00:00"
    }
  }
)

// When there is a end date with no end time, set the end time to 23:59 automatically.
// We need to do this because the API always expects a time.
watch(
  () => regularWorkFilters.value.performedRange?.endTime,
  () => {
    if (
      regularWorkFilters.value.performedRange &&
      !regularWorkFilters.value.performedRange.endTime
    ) {
      regularWorkFilters.value.performedRange.endTime = "23:59"
    }
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_toggle = _resolveComponent("q-toggle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogFilter.performed_regular_work")), 1),
      _createVNode(SfxBtnIcon, {
        icon: _unref(Icons).CHEVRON_DOWN,
        class: _normalizeClass(filterExpandIconClasses.value),
        size: "24px",
        onClick: handleFiltersSection
      }, null, 8, ["icon", "class"]),
      _createVNode(_component_q_space),
      (hasFilters.value)
        ? (_openBlock(), _createBlock(SfxBtnIcon, {
            key: 0,
            icon: _unref(Icons).UNDO,
            size: "24px",
            onClick: resetFilters
          }, null, 8, ["icon"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["text-subtitle1 text-fun-label-and-icon", filterExpandSectionClasses.value])
    }, [
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.simple")) + " ", 1),
        _createVNode(_component_q_toggle, {
          modelValue: regularWorkFilters.value.isRangeTemporal,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((regularWorkFilters.value.isRangeTemporal) = $event))
        }, null, 8, ["modelValue"]),
        _createTextVNode(" " + _toDisplayString(_unref(t)("sfxDialogFilter.range")), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["row items-center", regularWorkFilters.value.isRangeTemporal ? 'q-py-md' : 'q-py-xs'])
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("sfxDialogFilter.performed")), 1),
        (regularWorkFilters.value.isRangeTemporal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SfxSelect, {
                  class: "col q-pr-sm",
                  modelValue: regularWorkFilters.value.performedRange.timeLine,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((regularWorkFilters.value.performedRange.timeLine) = $event)),
                  options: timeLineOptions,
                  "emit-value": "",
                  "map-options": ""
                }, null, 8, ["modelValue"]),
                _createVNode(SfxTimeEdit, {
                  class: "col-5 q-pr-sm",
                  date: regularWorkFilters.value.performedRange.startDate,
                  "onUpdate:date": _cache[2] || (_cache[2] = ($event: any) => ((regularWorkFilters.value.performedRange.startDate) = $event)),
                  time: regularWorkFilters.value.performedRange.startTime,
                  "onUpdate:time": _cache[3] || (_cache[3] = ($event: any) => ((regularWorkFilters.value.performedRange.startTime) = $event)),
                  label: _unref(t)('sfxTimeEdit.label_range_start')
                }, null, 8, ["date", "time", "label"]),
                _createElementVNode("div", {
                  class: _normalizeClass(["col-5", endDateClasses.value]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (
              !regularWorkFilters.value.performedRange.startDate &&
                _unref(showWarningNotification)(_unref(t)('sfxDialogFilter.notify_disable_time'))
            ))
                }, [
                  _createVNode(SfxTimeEdit, {
                    date: regularWorkFilters.value.performedRange.endDate,
                    "onUpdate:date": _cache[4] || (_cache[4] = ($event: any) => ((regularWorkFilters.value.performedRange.endDate) = $event)),
                    time: regularWorkFilters.value.performedRange.endTime,
                    "onUpdate:time": _cache[5] || (_cache[5] = ($event: any) => ((regularWorkFilters.value.performedRange.endTime) = $event)),
                    label: _unref(t)('sfxTimeEdit.label_range_end'),
                    "start-date": regularWorkFilters.value.performedRange.startDate,
                    "start-time": regularWorkFilters.value.performedRange.startTime,
                    disable: !regularWorkFilters.value.performedRange.startDate
                  }, null, 8, ["date", "time", "label", "start-date", "start-time", "disable"])
                ], 2)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(SfxSelect, {
                class: "q-pr-sm",
                style: {"width":"138px"},
                modelValue: regularWorkFilters.value.performedSimple.timeLine,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((regularWorkFilters.value.performedSimple.timeLine) = $event)),
                options: timeLineOptions,
                "emit-value": "",
                "map-options": ""
              }, null, 8, ["modelValue"]),
              _createVNode(SfxSelectInequality, {
                class: "q-pr-sm",
                modelValue: regularWorkFilters.value.performedSimple.operator,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((regularWorkFilters.value.performedSimple.operator) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(SfxNumericSelector, {
                class: "q-pr-sm",
                modelValue: regularWorkFilters.value.performedSimple.number,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((regularWorkFilters.value.performedSimple.number) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(SfxSelect, {
                style: {"width":"138px"},
                modelValue: regularWorkFilters.value.performedSimple.calendrical,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((regularWorkFilters.value.performedSimple.calendrical) = $event)),
                options: calendricalOptions,
                "emit-value": "",
                "map-options": ""
              }, null, 8, ["modelValue"])
            ]))
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)("sfxDialogFilter.work_domain")), 1),
        _createVNode(SfxSelect, {
          class: "col-10",
          placeholder: _unref(t)('sfxDialogFilter.place_holder_work_domain'),
          modelValue: regularWorkFilters.value.workDomain,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((regularWorkFilters.value.workDomain) = $event)),
          options: props.workDomainOptions,
          "option-label": (opt) => opt.designation,
          "option-value": (opt) => opt.id,
          loading: props.workDomainOptions?.length === 0,
          "emit-value": "",
          "map-options": "",
          "use-chips": "",
          multiple: ""
        }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)("sfxDialogFilter.designation")), 1),
        _createVNode(SfxInput, {
          class: "col-10",
          "place-holder": _unref(t)('sfxDialogFilter.place_holder_designation'),
          modelValue: regularWorkFilters.value.designation,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((regularWorkFilters.value.designation) = $event)),
          "hide-bottom-space": ""
        }, null, 8, ["place-holder", "modelValue"])
      ])
    ], 2)
  ], 64))
}
}

})